import { TableRow } from '@getsynapse/design-system';
import moment from 'moment';
import { getUserAvartarColumn } from 'Organisms/DashboardDrilldown/helpers';
import intl from 'react-intl-universal';
import { EventDrillDownItem } from 'types/store/normalized/insightsDrillDown';
import { DATE } from 'utils/constants';

type EventDrillDownTableRowProps = {
  event: EventDrillDownItem;
};

const EventDrillDownTableRow = ({ event }: EventDrillDownTableRowProps) => {
  return (
    <TableRow
      id={event.id}
      className='group cursor-pointer'
      cells={[
        {
          content: event.title,
        },
        {
          content: event.event_type,
        },
        {
          content: event.is_all_day
            ? moment(event.start_timestamp).format(DATE.SHORT_FORMAT)
            : moment(event.start_timestamp).format(DATE.SHORT_FORMAT_WITH_TIME),
        },
        {
          content: event.is_all_day
            ? moment(event.end_timestamp).format(DATE.SHORT_FORMAT)
            : moment(event.end_timestamp).format(DATE.SHORT_FORMAT_WITH_TIME),
        },
        {
          content:
            event.facilitator_count > 0 &&
            getUserAvartarColumn(
              event.facilitator_data.map((facilitator) => ({
                avatar_url: facilitator.avatar_url,
                status: facilitator.status,
                data: {
                  firstName: facilitator.first_name,
                  lastName: facilitator.last_name,
                },
              }))
            ),
        },
        {
          content: event.is_recurring ? intl.get('YES') : intl.get('NO'),
        },
        {
          content: event.event_days,
        },
        {
          content: intl.get('HOURS_AMOUNT', {
            hours: event.duration_hours_per_day,
          }),
        },
        {
          content: intl.get('HOURS_AMOUNT', {
            hours: event.total_duration_hours,
          }),
        },
        {
          content: event.event_days_in_range,
        },
        {
          content: intl.get('HOURS_AMOUNT', {
            hours: event.duration_hours_in_range,
          }),
        },
      ]}
    />
  );
};

export default EventDrillDownTableRow;
